import { Translations } from '../types';

export const translations: Translations = {
  nav: {
    en: {
      home: 'Home',
      about: 'About',
      portfolio: 'Portfolio',
      products: 'Products',
      blog: 'Blog',
      contact: 'Contact',
      tools: 'Tools',
      subscribe: 'Subscribe',
      getUpdates: 'Get Updates',
      services: 'Services',
      maybeLater: 'Maybe later',
      cancel: 'Cancel',
      'free tools': 'Free Tools',
      'hire me': 'Hire Me'
    },
    tr: {
      home: 'Ana Sayfa',
      about: 'Hakkımda',
      portfolio: 'Portfolyo',
      products: 'Ürünler',
      blog: 'Blog',
      contact: 'İletişim',
      tools: 'Araçlar',
      subscribe: 'Abone Ol',
      getUpdates: 'Güncellemeler',
      services: 'Hizmetler',
      maybeLater: 'Belki sonra',
      cancel: 'İptal',
      'free tools': 'Ücretsiz Araçlar',
      'hire me': 'Beni İşe Al'
    },
    pl: {
      home: 'Strona główna',
      about: 'O mnie',
      portfolio: 'Portfolio',
      products: 'Produkty',
      blog: 'Blog',
      contact: 'Kontakt',
      tools: 'Narzędzia',
      subscribe: 'Subskrybuj',
      getUpdates: 'Aktualizacje',
      services: 'Usługi',
      maybeLater: 'Może później',
      cancel: 'Anuluj',
      'free tools': 'Darmowe Narzędzia',
      'hire me': 'Zatrudnij Mnie'
    },
    de: {
      home: 'Startseite',
      about: 'Über mich',
      portfolio: 'Portfolio',
      products: 'Produkte',
      blog: 'Blog',
      contact: 'Kontakt',
      tools: 'Werkzeuge',
      subscribe: 'Abonnieren',
      getUpdates: 'Updates',
      services: 'Dienstleistungen',
      maybeLater: 'Vielleicht später',
      cancel: 'Abbrechen',
      'free tools': 'Kostenlose Tools',
      'hire me': 'Beauftragen'
    }
  },
  portfolio: {
    en: {
      title: 'Projects',
      subtitle: 'Tools and products I have built and shipped.',
      categories: {
        all: 'All',
        saas: 'SaaS',
        mobile: 'Mobile',
        chrome: 'Chrome',
        ebook: 'Guides',
        course: 'Courses',
        consultation: 'Consulting',
        webdesign: 'Web Design',
        ecommerce: 'E-commerce',
        restaurant: 'Restaurant'
      },
      noProjects: 'No projects found.',
      featuredLabel: 'Featured',
      viewProject: 'View Project',
      stats: {
        users: 'Users',
        downloads: 'Downloads'
      },
      projects: {
        '1': {
          title: 'Phonetic Pro',
          description: 'Convert text to phonetic alphabets in real-time. Free Chrome extension for linguists and teachers.'
        },
        'local-route': {
          title: 'Local Route',
          description: 'Launch URLs instantly. Organize bookmarks, use fuzzy search, navigate with keyboard shortcuts.'
        },
        '2': {
          title: 'Secure For Free',
          description: 'Essential security tools and resources for developers and businesses.'
        },
        '3': {
          title: 'Sellerbase.eu',
          description: 'Community platform where e-commerce sellers connect and share strategies.'
        },
        '4': {
          title: 'AtesITSolutions.com',
          description: 'Digital marketing and web development solutions for growing businesses.'
        },
        '5': {
          title: 'EmelKedik.com',
          description: 'YouTube vlogs and automated blog platform for content creators.'
        }
      }
    },
    tr: {
      title: 'Projeler',
      subtitle: 'Oluşturduğum ve yayınladığım araçlar ve ürünler.',
      categories: {
        all: 'Hepsi',
        saas: 'SaaS',
        mobile: 'Mobil',
        chrome: 'Chrome',
        ebook: 'Rehberler',
        course: 'Kurslar',
        consultation: 'Danışmanlık',
        webdesign: 'Web Tasarım',
        ecommerce: 'E-ticaret',
        restaurant: 'Restoran'
      },
      noProjects: 'Proje bulunamadı.',
      featuredLabel: 'Öne Çıkan',
      viewProject: 'Projeyi Gör',
      stats: {
        users: 'Kullanıcı',
        downloads: 'İndirme'
      },
      projects: {
        '1': {
          title: 'Phonetic Pro',
          description: 'Metni gerçek zamanlı olarak fonetik alfabeye dönüştürün. Dilbilimciler ve öğretmenler için ücretsiz Chrome uzantısı.'
        },
        'local-route': {
          title: 'Local Route',
          description: 'URL\'leri anında başlatın. Yer imlerini düzenleyin, bulanık arama kullanın, klavye kısayollarıyla gezinin.'
        },
        '2': {
          title: 'Secure For Free',
          description: 'Geliştiriciler ve işletmeler için temel güvenlik araçları ve kaynakları.'
        },
        '3': {
          title: 'Sellerbase.eu',
          description: 'E-ticaret satıcılarının bağlantı kurduğu ve strateji paylaştığı topluluk platformu.'
        },
        '4': {
          title: 'AtesITSolutions.com',
          description: 'Büyüyen işletmeler için dijital pazarlama ve web geliştirme çözümleri.'
        },
        '5': {
          title: 'EmelKedik.com',
          description: 'İçerik oluşturucular için YouTube vlogları ve otomatik blog platformu.'
        }
      }
    },
    pl: {
      title: 'Projekty',
      subtitle: 'Narzędzia i produkty które zbudowałem i opublikowałem.',
      categories: {
        all: 'Wszystkie',
        saas: 'SaaS',
        mobile: 'Mobilne',
        chrome: 'Chrome',
        ebook: 'Przewodniki',
        course: 'Kursy',
        consultation: 'Konsulting',
        webdesign: 'Web Design',
        ecommerce: 'E-commerce',
        restaurant: 'Restauracja'
      },
      noProjects: 'Nie znaleziono projektów.',
      featuredLabel: 'Wyróżnione',
      viewProject: 'Zobacz Projekt',
      stats: {
        users: 'Użytkowników',
        downloads: 'Pobrań'
      },
      projects: {
        '1': {
          title: 'Phonetic Pro',
          description: 'Konwertuj tekst na alfabety fonetyczne w czasie rzeczywistym. Darmowe rozszerzenie Chrome dla lingwistów i nauczycieli.'
        },
        'local-route': {
          title: 'Local Route',
          description: 'Uruchamiaj URL natychmiast. Organizuj zakładki, używaj wyszukiwania, nawiguj skrótami klawiszowymi.'
        },
        '2': {
          title: 'Secure For Free',
          description: 'Podstawowe narzędzia bezpieczeństwa i zasoby dla developerów i firm.'
        },
        '3': {
          title: 'Sellerbase.eu',
          description: 'Platforma społecznościowa gdzie sprzedawcy e-commerce łączą się i dzielą strategiami.'
        },
        '4': {
          title: 'AtesITSolutions.com',
          description: 'Rozwiązania marketingu cyfrowego i web developmentu dla rozwijających się firm.'
        },
        '5': {
          title: 'EmelKedik.com',
          description: 'Vlogi YouTube i zautomatyzowana platforma blogowa dla twórców treści.'
        }
      }
    },
    de: {
      title: 'Projekte',
      subtitle: 'Tools und Produkte die ich gebaut und veröffentlicht habe.',
      categories: {
        all: 'Alle',
        saas: 'SaaS',
        mobile: 'Mobil',
        chrome: 'Chrome',
        ebook: 'Guides',
        course: 'Kurse',
        consultation: 'Beratung',
        webdesign: 'Webdesign',
        ecommerce: 'E-Commerce',
        restaurant: 'Restaurant'
      },
      noProjects: 'Keine Projekte gefunden.',
      featuredLabel: 'Hervorgehoben',
      viewProject: 'Projekt Ansehen',
      stats: {
        users: 'Nutzer',
        downloads: 'Downloads'
      },
      projects: {
        '1': {
          title: 'Phonetic Pro',
          description: 'Text in Echtzeit in phonetische Alphabete umwandeln. Kostenlose Chrome-Erweiterung für Linguisten und Lehrer.'
        },
        'local-route': {
          title: 'Local Route',
          description: 'URLs sofort starten. Lesezeichen organisieren, Fuzzy-Suche nutzen, mit Shortcuts navigieren.'
        },
        '2': {
          title: 'Secure For Free',
          description: 'Grundlegende Sicherheitstools und Ressourcen für Entwickler und Unternehmen.'
        },
        '3': {
          title: 'Sellerbase.eu',
          description: 'Community-Plattform wo E-Commerce-Verkäufer sich verbinden und Strategien teilen.'
        },
        '4': {
          title: 'AtesITSolutions.com',
          description: 'Digitales Marketing und Webentwicklung für wachsende Unternehmen.'
        },
        '5': {
          title: 'EmelKedik.com',
          description: 'YouTube-Vlogs und automatisierte Blog-Plattform für Content-Ersteller.'
        }
      }
    }
  },
  localRoute: {
    en: {
      badge: 'Free Chrome Extension',
      heroTitle_line1: 'Launch URLs at',
      heroTitle_gradient: 'Lightning Speed',
      heroSubtitle: 'Stop wasting time searching for bookmarks. Organize your URLs into categories, add keyboard shortcuts, and launch them instantly with fuzzy search.',
      ctaInstall: 'Add to Chrome - Free',
      ctaFeatures: 'See Features',
      browserTitle: 'Local Route Extension',
      searchPlaceholder: 'Search shortcuts...',
      feature1Title: 'Smart Categories',
      feature1Desc: 'Organize URLs into custom categories with icons.',
      feature2Title: 'Fuzzy Search',
      feature2Desc: 'Find any shortcut instantly with intelligent fuzzy search.',
      feature3Title: 'Keyboard Shortcuts',
      feature3Desc: 'Assign custom keyboard shortcuts to your most-used URLs.',
      feature4Title: 'Multiple Profiles',
      feature4Desc: 'Create separate profiles for work, personal, or projects.',
      feature5Title: 'Instant Launch',
      feature5Desc: 'Open multiple URLs at once or launch single sites.',
      feature6Title: '100% Private',
      feature6Desc: 'All data stored locally in your browser. No accounts, no tracking.',
      howItWorksTitle: 'Get Started in',
      howItWorksSeconds: 'Seconds',
      howItWorksStep1: 'Install the Extension',
      howItWorksStep1Desc: 'Add Local Route to Chrome with one click.',
      howItWorksStep2: 'Add Your Shortcuts',
      howItWorksStep2Desc: 'Import bookmarks or manually add URLs.',
      howItWorksStep3: 'Launch Instantly',
      howItWorksStep3Desc: 'Use search, keyboard shortcuts, or click to open.',
      testimonialsTitle: 'Loved by',
      testimonialsThousands: 'Thousands',
      ctaReadyTitle: 'Ready to Launch Faster?',
      ctaReadySubtitle: 'Install Local Route now and start saving time.',
      faqTitle: 'Frequently Asked',
      faqQuestions: 'Questions',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      moreQuestions: 'Have more questions? Check our',
      checkFree: 'Free Forever',
      checkNoAccount: 'No Account Needed',
      checkPrivate: '100% Private',
      faqQ1: 'Is Local Route really free?',
      faqA1: 'Yes, Local Route is completely free to use. There are no premium tiers, subscriptions, or hidden costs. All features are available to everyone.',
      faqQ2: 'Does Local Route collect my data?',
      faqA2: 'No. All your data is stored locally in your browser using Chrome\'s storage API. We don\'t have servers, don\'t collect analytics, and never see your shortcuts or browsing data.',
      faqQ3: 'Can I sync my shortcuts across devices?',
      faqA3: 'Currently, shortcuts are stored locally on each device. You can export and import your shortcuts using the built-in backup feature to transfer them between devices.',
      faqQ4: 'How do keyboard shortcuts work?',
      faqA4: 'You can assign custom keyboard combinations to any shortcut. When you press the combination, the URL opens instantly. This works even when the popup is closed.',
      faqQ5: 'What browsers are supported?',
      faqA5: 'Local Route is currently available for Google Chrome and Chromium-based browsers like Brave, Edge, and Opera.'
    },
    tr: {
      badge: 'Ücretsiz Chrome Uzantısı',
      heroTitle_line1: 'URL\'leri Başlatın',
      heroTitle_gradient: 'Işık Hızında',
      heroSubtitle: 'Yer imlerini aramakla vakit kaybetmeyin. URL\'lerinizi kategorilere ayırın ve anında başlatın.',
      ctaInstall: 'Chrome\'a Ekle - Ücretsiz',
      ctaFeatures: 'Özellikleri Gör',
      browserTitle: 'Local Route Uzantısı',
      searchPlaceholder: 'Kısayollarda ara...',
      feature1Title: 'Akıllı Kategoriler',
      feature1Desc: 'URL\'leri özel kategorilere ayırın.',
      feature2Title: 'Bulanık Arama',
      feature2Desc: 'Herhangi bir kısayolu anında bulun.',
      feature3Title: 'Klavye Kısayolları',
      feature3Desc: 'En çok kullandığınız URL\'lere kısayollar atayın.',
      feature4Title: 'Çoklu Profiller',
      feature4Desc: 'İş veya kişisel için ayrı profiller oluşturun.',
      feature5Title: 'Anında Başlatma',
      feature5Desc: 'Tek seferde birden fazla URL açın.',
      feature6Title: '%100 Gizli',
      feature6Desc: 'Tüm veriler tarayıcınızda yerel olarak saklanır.',
      howItWorksTitle: 'Saniyeler İçinde',
      howItWorksSeconds: 'Başlayın',
      howItWorksStep1: 'Uzantıyı Yükleyin',
      howItWorksStep1Desc: 'Local Route\'u tek tıkla Chrome\'a ekleyin.',
      howItWorksStep2: 'Kısayollarınızı Ekleyin',
      howItWorksStep2Desc: 'Yer imlerinizi içe aktarın veya manuel ekleyin.',
      howItWorksStep3: 'Anında Başlatın',
      howItWorksStep3Desc: 'Aramayı veya klavye kısayollarını kullanın.',
      testimonialsTitle: 'Binlerce Kişi',
      testimonialsThousands: 'Tarafından Sevildi',
      ctaReadyTitle: 'Daha Hızlı Başlatmaya Hazır mısınız?',
      ctaReadySubtitle: 'Local Route\'u şimdi yükleyin ve zaman kazanmaya başlayın.',
      faqTitle: 'Sıkça Sorulan',
      faqQuestions: 'Sorular',
      privacyPolicy: 'Gizlilik Politikası',
      termsOfService: 'Kullanım Şartları',
      moreQuestions: 'Daha fazla sorunuz mu var? Şuna bak:',
      checkFree: 'Sonsuza Kadar Ücretsiz',
      checkNoAccount: 'Hesap Gerekmez',
      checkPrivate: '%100 Gizli',
      faqQ1: 'Local Route gerçekten ücretsiz mi?',
      faqA1: 'Evet, Local Route tamamen ücretsizdir. Ücretli katmanlar, abonelikler veya gizli maliyetler yoktur.',
      faqQ2: 'Local Route verilerimi topluyor mu?',
      faqA2: 'Hayır. Tüm verileriniz tarayıcınızda yerel olarak saklanır. Sunucumuz yoktur ve verilerinizi asla görmeyiz.',
      faqQ3: 'Kısayollarımı cihazlar arasında senkronize edebilir miyim?',
      faqA3: 'Şu anda kısayollar her cihazda yerel olarak saklanır. Yedekleme özelliğini kullanarak dışa ve içe aktarabilirsiniz.',
      faqQ4: 'Klavye kısayolları nasıl çalışır?',
      faqA4: 'Herhangi bir URL için özel tuş kombinasyonları atayabilirsiniz. Popup kapalıyken bile çalışır.',
      faqQ5: 'Hangi tarayıcılar destekleniyor?',
      faqA5: 'Local Route şu anda Chrome ve Chromium tabanlı (Brave, Edge, Opera) tarayıcılarda mevcuttur.'
    },
    pl: {
      badge: 'Darmowe Rozszerzenie Chrome',
      heroTitle_line1: 'Uruchamiaj URL z',
      heroTitle_gradient: 'Prędkością Światła',
      heroSubtitle: 'Przestań marnować czas na szukanie zakładek. Organizuj adresy URL w kategorie i uruchamiaj je błyskawicznie.',
      ctaInstall: 'Dodaj do Chrome - Za darmo',
      ctaFeatures: 'Zobacz funkcje',
      browserTitle: 'Rozszerzenie Local Route',
      searchPlaceholder: 'Szukaj skrótów...',
      feature1Title: 'Inteligentne Kategorie',
      feature1Desc: 'Organizuj adresy URL w niestandardowe kategorie.',
      feature2Title: 'Wyszukiwanie rozmyte',
      feature2Desc: 'Znajdź dowolny skrót natychmiast.',
      feature3Title: 'Skróty klawiszowe',
      feature3Desc: 'Przypisz skróty do najczęściej używanych adresów.',
      feature4Title: 'Wiele profili',
      feature4Desc: 'Twórz osobne profile do pracy i celów prywatnych.',
      feature5Title: 'Natychmiastowy start',
      feature5Desc: 'Otwieraj wiele adresów URL naraz.',
      feature6Title: '100% Prywatności',
      feature6Desc: 'Wszystkie dane przechowywane lokalnie w przeglądarce.',
      howItWorksTitle: 'Zacznij w',
      howItWorksSeconds: 'Sekundy',
      howItWorksStep1: 'Zainstaluj rozszerzenie',
      howItWorksStep1Desc: 'Dodaj Local Route do Chrome jednym kliknięciem.',
      howItWorksStep2: 'Dodaj skróty',
      howItWorksStep2Desc: 'Importuj zakładki lub dodaj je ręcznie.',
      howItWorksStep3: 'Uruchamiaj natychmiast',
      howItWorksStep3Desc: 'Użyj wyszukiwarki lub skrótów klawiszowych.',
      testimonialsTitle: 'Uwielbiany przez',
      testimonialsThousands: 'Tysiące',
      ctaReadyTitle: 'Gotowy na szybszy start?',
      ctaReadySubtitle: 'Zainstaluj Local Route teraz i oszczędzaj czas.',
      faqTitle: 'Często Zadawane',
      faqQuestions: 'Pytania',
      privacyPolicy: 'Polityka Prywatności',
      termsOfService: 'Warunki Serwisu',
      moreQuestions: 'Masz więcej pytań? Sprawdź:',
      checkFree: 'Zawsze za darmo',
      checkNoAccount: 'Bez konta',
      checkPrivate: '100% Prywatności',
      faqQ1: 'Czy Local Route jest naprawdę darmowy?',
      faqA1: 'Tak, Local Route jest całkowicie darmowy. Nie ma płatnych opcji ani ukrytych kosztów.',
      faqQ2: 'Czy Local Route zbiera moje dane?',
      faqA2: 'Nie. Wszystkie dane są przechowywane lokalnie w przeglądarce. Nie mamy serwerów ani analityki.',
      faqQ3: 'Czy mogę synchronizować skróty między urządzeniami?',
      faqA3: 'Obecnie skróty są lokalne. Możesz je eksportować i importować ręcznie.',
      faqQ4: 'Jak działają skróty klawiszowe?',
      faqA4: 'Możesz przypisać kombinacje klawiszy do dowolnego URL. Działa to nawet gdy popup jest zamknięty.',
      faqQ5: 'Które przeglądarki są wspierane?',
      faqA5: 'Local Route działa w Chrome i przeglądarkach Chromium (Brave, Edge, Opera).'
    },
    de: {
      badge: 'Kostenlose Chrome-Erweiterung',
      heroTitle_line1: 'URLs starten in',
      heroTitle_gradient: 'Lichtgeschwindigkeit',
      heroSubtitle: 'Verschwenden Sie keine Zeit mit Lesezeichen. Organisieren Sie Ihre URLs und starten Sie sofort.',
      ctaInstall: 'Zu Chrome hinzufügen',
      ctaFeatures: 'Funktionen ansehen',
      browserTitle: 'Local Route Erweiterung',
      searchPlaceholder: 'Shortcuts suchen...',
      feature1Title: 'Smarte Kategorien',
      feature1Desc: 'URLs in Kategorien mit Icons organisieren.',
      feature2Title: 'Fuzzy-Suche',
      feature2Desc: 'Jeden Shortcut sofort finden.',
      feature3Title: 'Tastenkombinationen',
      feature3Desc: 'Eigene Shortcuts für Ihre URLs zuweisen.',
      feature4Title: 'Mehrere Profile',
      feature4Desc: 'Separate Profile für Arbeit und Privat erstellen.',
      feature5Title: 'Sofortiger Start',
      feature5Desc: 'Mehrere URLs gleichzeitig öffnen.',
      feature6Title: '100% Privat',
      feature6Desc: 'Alle Daten werden lokal im Browser gespeichert.',
      howItWorksTitle: 'In Sekunden',
      howItWorksSeconds: 'loslegen',
      howItWorksStep1: 'Erweiterung installieren',
      howItWorksStep1Desc: 'Local Route mit einem Klick hinzufügen.',
      howItWorksStep2: 'Shortcuts hinzufügen',
      howItWorksStep2Desc: 'Lesezeichen importieren oder manuell hinzufügen.',
      howItWorksStep3: 'Sofort starten',
      howItWorksStep3Desc: 'Suche oder Keyboard-Shortcuts nutzen.',
      testimonialsTitle: 'Beliebt bei',
      testimonialsThousands: 'Tausenden',
      ctaReadyTitle: 'Bereit schneller zu starten?',
      ctaReadySubtitle: 'Local Route jetzt installieren.',
      faqTitle: 'Häufig gestellte',
      faqQuestions: 'Fragen',
      privacyPolicy: 'Datenschutz',
      termsOfService: 'Nutzungsbedingungen',
      moreQuestions: 'Noch Fragen? Siehe:',
      checkFree: 'Für immer kostenlos',
      checkNoAccount: 'Kein Konto nötig',
      checkPrivate: '100% Privat',
      faqQ1: 'Ist Local Route wirklich kostenlos?',
      faqA1: 'Ja, Local Route ist völlig kostenlos. Keine Premium-Optionen oder versteckte Gebühren.',
      faqQ2: 'Sammelt Local Route meine Daten?',
      faqA2: 'Nein. Alle Daten werden lokal im Browser gespeichert. Wir haben keine Server.',
      faqQ3: 'Kann ich Shortcuts geräteübergreifend synchronisieren?',
      faqA3: 'Aktuell werden sie lokal gespeichert. Export/Import ist manuell möglich.',
      faqQ4: 'Wie funktionieren Tastenkombinationen?',
      faqA4: 'Sie können eigene Shortcuts für jede URL festlegen. Funktioniert auch bei geschlossenem Popup.',
      faqQ5: 'Welche Browser werden unterstützt?',
      faqA5: 'Local Route ist für Chrome und Chromium-basierte Browser verfügbar.'
    }
  },
  hero: {
    en: {
      title: 'Free Tools for Makers Who Ship',
      subtitle: 'Browser extensions and digital tools built by a founder, for founders. Simple. Private. Ready to use.',
      available: 'Available for projects',
      scrollDown: 'See what I build'
    },
    tr: {
      title: 'Ürün Çıkaran Yapımcılar İçin Ücretsiz Araçlar',
      subtitle: 'Bir kurucu tarafından, kurucular için oluşturulmuş tarayıcı eklentileri ve dijital araçlar. Basit. Gizli. Kullanıma hazır.',
      available: 'Projelere açık',
      scrollDown: 'Ne yaptığımı gör'
    },
    pl: {
      title: 'Darmowe Narzędzia dla Twórców',
      subtitle: 'Rozszerzenia przeglądarki i narzędzia cyfrowe stworzone przez foundera, dla founderów. Proste. Prywatne. Gotowe do użycia.',
      available: 'Dostępny dla projektów',
      scrollDown: 'Zobacz co tworzę'
    },
    de: {
      title: 'Kostenlose Tools für Macher',
      subtitle: 'Browser-Erweiterungen und digitale Tools, von einem Gründer für Gründer. Einfach. Privat. Einsatzbereit.',
      available: 'Verfügbar für Projekte',
      scrollDown: 'Entdecke meine Projekte'
    }
  },
  products: {
    en: {
      title: 'My Products',
      subtitle: 'Tools I use daily. Now available for you.',
      saas: {
        title: 'SaaS Platform',
        description: 'Enterprise-grade SaaS solution for business automation'
      },
      mobile: {
        title: 'Mobile App',
        description: 'Cross-platform mobile application for productivity'
      },
      chrome: {
        title: 'Chrome Extension',
        description: 'Powerful browser extension for developers'
      }
    },
    tr: {
      title: 'Ürünlerim',
      subtitle: 'Her gün kullandığım araçlar. Artık sizin için de mevcut.',
      saas: {
        title: 'SaaS Platformu',
        description: 'İşletmeler için kurumsal düzeyde SaaS otomasyon çözümü'
      },
      mobile: {
        title: 'Mobil Uygulama',
        description: 'Verimlilik için çoklu platform mobil uygulaması'
      },
      chrome: {
        title: 'Chrome Eklentisi',
        description: 'Geliştiriciler için güçlü tarayıcı eklentisi'
      }
    },
    pl: {
      title: 'Moje Produkty',
      subtitle: 'Narzędzia których sam używam codziennie. Teraz dostępne dla Ciebie.',
      saas: {
        title: 'Platforma SaaS',
        description: 'Rozwiązanie SaaS klasy korporacyjnej do automatyzacji biznesu'
      },
      mobile: {
        title: 'Aplikacja Mobilna',
        description: 'Wieloplatformowa aplikacja mobilna zwiększająca produktywność'
      },
      chrome: {
        title: 'Rozszerzenie Chrome',
        description: 'Potężne rozszerzenie przeglądarki dla programistów'
      }
    },
    de: {
      title: 'Meine Produkte',
      subtitle: 'Tools die ich täglich nutze. Jetzt auch für dich verfügbar.',
      saas: {
        title: 'SaaS-Plattform',
        description: 'SaaS-Lösung für die Geschäftsautomatisierung'
      },
      mobile: {
        title: 'Mobile App',
        description: 'Plattformübergreifende mobile Anwendung für Produktivität'
      },
      chrome: {
        title: 'Chrome-Erweiterung',
        description: 'Leistungsstarke Browser-Erweiterung für Entwickler'
      }
    }
  },
  services: {
    en: {
      title: 'How I Can Help',
      development: {
        title: 'Web Applications',
        description: 'Custom SaaS and web apps built with modern, scalable technology.'
      },
      mobile: {
        title: 'Mobile Apps',
        description: 'Native and cross-platform apps for iOS and Android.'
      },
      extensions: {
        title: 'Browser Extensions',
        description: 'Chrome extensions that solve real problems for your users.'
      },
      ebooks: {
        title: 'Digital Guides',
        description: 'Practical e-books on e-commerce and tech topics.'
      },
      courses: {
        title: 'Online Courses',
        description: 'Step-by-step courses for sellers and makers.'
      },
      consulting: {
        title: '1-on-1 Consulting',
        description: 'Personal strategy sessions for your e-commerce business.',
        features: ['Business Strategy', 'Architecture Review', 'Performance Audit', 'Growth Planning']
      },
      pageTitle: 'Services',
      pageSubtitle: 'Focused solutions for makers and sellers. No fluff, just results.',
      learnMore: 'Learn More',
      developmentFeatures: ['Custom Web Apps', 'SaaS Platforms', 'API Development', 'Cloud Integration'],
      mobileFeatures: ['iOS Apps', 'Android Apps', 'React Native', 'App Store Launch'],
      extensionsFeatures: ['Chrome Extensions', 'Productivity Tools', 'Automation', 'Publishing Support'],
      ebooksFeatures: ['E-commerce Guides', 'Tech Tutorials', 'Strategy Playbooks', 'Best Practices'],
      coursesFeatures: ['Video Lessons', 'Practical Projects', 'Community Access', 'Lifetime Updates']
    },
    tr: {
      title: 'Nasıl Yardımcı Olabilirim',
      development: {
        title: 'Web Uygulamaları',
        description: 'Modern ve ölçeklenebilir teknoloji ile özel SaaS ve web uygulamaları.'
      },
      mobile: {
        title: 'Mobil Uygulamalar',
        description: 'iOS ve Android için yerel ve çapraz platform uygulamalar.'
      },
      extensions: {
        title: 'Tarayıcı Uzantıları',
        description: 'Kullanıcılarınız için gerçek sorunları çözen Chrome uzantıları.'
      },
      ebooks: {
        title: 'Dijital Rehberler',
        description: 'E-ticaret ve teknoloji konularında pratik e-kitaplar.'
      },
      courses: {
        title: 'Online Kurslar',
        description: 'Satıcılar ve yapımcılar için adım adım kurslar.'
      },
      consulting: {
        title: 'Birebir Danışmanlık',
        description: 'E-ticaret işiniz için kişisel strateji oturumları.',
        features: ['İş Stratejisi', 'Mimari İnceleme', 'Performans Denetimi', 'Büyüme Planlaması']
      },
      pageTitle: 'Hizmetler',
      pageSubtitle: 'Yapımcılar ve satıcılar için odaklı çözümler. Sadece sonuçlar.',
      learnMore: 'Daha Fazla',
      developmentFeatures: ['Özel Web Uygulamaları', 'SaaS Platformları', 'API Geliştirme', 'Bulut Entegrasyonu'],
      mobileFeatures: ['iOS Uygulamaları', 'Android Uygulamaları', 'React Native', 'Uygulama Mağazası Lansmanı'],
      extensionsFeatures: ['Chrome Uzantıları', 'Verimlilik Araçları', 'Otomasyon', 'Yayınlama Desteği'],
      ebooksFeatures: ['E-ticaret Rehberleri', 'Teknik Eğitimler', 'Strateji Kitapları', 'En İyi Uygulamalar'],
      coursesFeatures: ['Video Dersler', 'Pratik Projeler', 'Topluluk Erişimi', 'Ömür Boyu Güncellemeler']
    },
    pl: {
      title: 'Jak Mogę Pomóc',
      development: {
        title: 'Aplikacje Webowe',
        description: 'Niestandardowe SaaS i aplikacje web z nowoczesną, skalowalną technologią.'
      },
      mobile: {
        title: 'Aplikacje Mobilne',
        description: 'Natywne i wieloplatformowe aplikacje na iOS i Android.'
      },
      extensions: {
        title: 'Rozszerzenia Przeglądarki',
        description: 'Rozszerzenia Chrome rozwiązujące prawdziwe problemy użytkowników.'
      },
      ebooks: {
        title: 'Przewodniki Cyfrowe',
        description: 'Praktyczne e-booki o e-commerce i technologii.'
      },
      courses: {
        title: 'Kursy Online',
        description: 'Kursy krok po kroku dla sprzedawców i twórców.'
      },
      consulting: {
        title: 'Konsultacje 1-na-1',
        description: 'Osobiste sesje strategiczne dla Twojego biznesu e-commerce.',
        features: ['Strategia Biznesowa', 'Przegląd Architektury', 'Audyt Wydajności', 'Planowanie Wzrostu']
      },
      pageTitle: 'Usługi',
      pageSubtitle: 'Skupione rozwiązania dla twórców i sprzedawców. Bez zbędników, tylko wyniki.',
      learnMore: 'Dowiedz się więcej',
      developmentFeatures: ['Niestandardowe Aplikacje Web', 'Platformy SaaS', 'Rozwój API', 'Integracja z Chmurą'],
      mobileFeatures: ['Aplikacje iOS', 'Aplikacje Android', 'React Native', 'Premiera w App Store'],
      extensionsFeatures: ['Rozszerzenia Chrome', 'Narzędzia Produktywności', 'Automatyzacja', 'Wsparcie Publikacji'],
      ebooksFeatures: ['Przewodniki E-commerce', 'Tutoriale Techniczne', 'Podręczniki Strategii', 'Dobre Praktyki'],
      coursesFeatures: ['Lekcje Wideo', 'Praktyczne Projekty', 'Dostęp do Społeczności', 'Dożywotnie Aktualizacje']
    },
    de: {
      title: 'Wie Ich Helfen Kann',
      development: {
        title: 'Web-Anwendungen',
        description: 'Maßgeschneiderte SaaS und Web-Apps mit moderner, skalierbarer Technologie.'
      },
      mobile: {
        title: 'Mobile Apps',
        description: 'Native und plattformübergreifende Apps für iOS und Android.'
      },
      extensions: {
        title: 'Browser-Erweiterungen',
        description: 'Chrome-Erweiterungen die echte Probleme für deine Nutzer lösen.'
      },
      ebooks: {
        title: 'Digitale Guides',
        description: 'Praktische E-Books zu E-Commerce und Tech-Themen.'
      },
      courses: {
        title: 'Online-Kurse',
        description: 'Schritt-für-Schritt Kurse für Verkäufer und Macher.'
      },
      consulting: {
        title: '1-zu-1 Beratung',
        description: 'Persönliche Strategie-Sessions für dein E-Commerce-Business.',
        features: ['Business-Strategie', 'Architektur-Review', 'Performance-Audit', 'Wachstumsplanung']
      },
      pageTitle: 'Dienstleistungen',
      pageSubtitle: 'Fokussierte Lösungen für Macher und Verkäufer. Keine Floskeln, nur Ergebnisse.',
      learnMore: 'Mehr erfahren',
      developmentFeatures: ['Maßgeschneiderte Web-Apps', 'SaaS-Plattformen', 'API-Entwicklung', 'Cloud-Integration'],
      mobileFeatures: ['iOS-Apps', 'Android-Apps', 'React Native', 'App Store Launch'],
      extensionsFeatures: ['Chrome-Erweiterungen', 'Produktivitäts-Tools', 'Automatisierung', 'Publishing-Support'],
      ebooksFeatures: ['E-Commerce-Guides', 'Tech-Tutorials', 'Strategie-Playbooks', 'Best Practices'],
      coursesFeatures: ['Video-Lektionen', 'Praktische Projekte', 'Community-Zugang', 'Lebenslange Updates']
    }
  },
  about: {
    en: {
      title: 'About Me',
      hero: 'Building Digital Experiences',
      subtitle: 'Full Stack Developer & Entrepreneur converting ideas into reality.',
      experience: {
        title: 'Experience',
        developer: {
          title: 'Full Stack Developer',
          position: 'Freelance',
          point1: 'Developed scalable web applications using React and Node.js.',
          point2: 'Integrated payment gateways and third-party APIs.',
          point3: 'Improved site performance and SEO rankings.',
          point4: 'Collaborated with clients to deliver custom solutions.'
        },
        ecommerce: {
          title: 'E-commerce Specialist',
          position: 'Consultant',
          point1: 'Managed multiple e-commerce stores.',
          point2: 'Optimized conversion rates and user journeys.',
          point3: 'Implemented automated marketing flows.',
          point4: 'Scaled revenue through data-driven decisions.'
        },
        marketing: {
          title: 'Digital Marketer',
          position: 'Strategist',
          point1: 'Planned and executed social media campaigns.',
          point2: 'Analyzed market trends and competitor strategies.',
          point3: 'Managed PPC advertising budgets.',
          point4: 'Generated high-quality leads for B2B clients.'
        }
      }
    },
    tr: {
      title: 'Hakkımda',
      hero: 'Dijital Deneyimler İnşa Ediyoruz',
      subtitle: 'Fikirleri gerçeğe dönüştüren Full Stack Geliştirici & Girişimci.',
      experience: {
        title: 'Deneyim',
        developer: {
          title: 'Full Stack Geliştirici',
          position: 'Freelance',
          point1: 'Ölçeklenebilir web uygulamaları geliştirme.',
          point2: 'Ödeme sistemleri entegrasyonu.',
          point3: 'Performans ve SEO optimizasyonu.',
          point4: 'Kişiye özel çözümler.'
        },
        ecommerce: {
          title: 'E-Ticaret Uzmanı',
          position: 'Danışman',
          point1: 'Online mağaza yönetimi.',
          point2: 'Dönüşüm optimizasyonu.',
          point3: 'Pazarlama otomasyonu.',
          point4: 'Gelir artırma.'
        },
        marketing: {
          title: 'Dijital Pazarlamacı',
          position: 'Stratejist',
          point1: 'Sosyal medya kampanyaları.',
          point2: 'Pazar analizi.',
          point3: 'PPC reklamcılığı.',
          point4: 'Lead oluşturma.'
        }
      }
    },
    pl: {
      title: 'O mnie',
      hero: 'Tworzenie Cyfrowych Doświadczeń',
      subtitle: 'Full Stack Developer i Przedsiębiorca zamieniający pomysły w rzeczywistość.',
      experience: {
        title: 'Doświadczenie',
        developer: {
          title: 'Full Stack Developer',
          position: 'Freelancer',
          point1: 'Tworzenie skalowalnych aplikacji webowych.',
          point2: 'Integracja systemów płatności.',
          point3: 'Optymalizacja wydajności i SEO.',
          point4: 'Współpraca z klientami.'
        },
        ecommerce: {
          title: 'Specjalista E-commerce',
          position: 'Konsultant',
          point1: 'Zarządzanie sklepami online.',
          point2: 'Optymalizacja konwersji.',
          point3: 'Automatyzacja marketingu.',
          point4: 'Skalowanie przychodów.'
        },
        marketing: {
          title: 'Marketer Cyfrowy',
          position: 'Strateg',
          point1: 'Kampanie w social media.',
          point2: 'Analiza rynku.',
          point3: 'Reklamy PPC.',
          point4: 'Generowanie leadów.'
        }
      },
    },
    de: {
      title: 'Über mich',
      hero: 'Digitale Erlebnisse schaffen',
      subtitle: 'Full Stack Entwickler & Unternehmer.',
      experience: {
        title: 'Erfahrung',
        developer: {
          title: 'Full Stack Entwickler',
          position: 'Freiberuflich',
          point1: 'Entwicklung skalierbarer Web-Apps.',
          point2: 'Integration von Zahlungs-APIs.',
          point3: 'Performance-Optimierung.',
          point4: 'Kundenspezifische Lösungen.'
        },
        ecommerce: {
          title: 'E-Commerce Spezialist',
          position: 'Berater',
          point1: 'Management von Online-Shops.',
          point2: 'Konversionsoptimierung.',
          point3: 'Marketing-Automatisierung.',
          point4: 'Umsatzsteigerung.'
        },
        marketing: {
          title: 'Digitaler Marketer',
          position: 'Stratege',
          point1: 'Social Media Kampagnen.',
          point2: 'Marktanalyse.',
          point3: 'PPC Werbung.',
          point4: 'Lead-Generierung.'
        }
      }
    }
  },
  skills: {
    en: {
      title: 'Skills',
      development: 'Development',
      mobile: 'Mobile',
      cloud: 'Cloud',
      ecommerce: 'E-commerce',
      marketing: 'Marketing',
      seo: 'SEO',
      content: 'Content',
      ppc: 'PPC',
      funnels: 'Funnels',
      business: 'Business',
      revenue: 'Revenue',
      market: 'Market',
      strategy: 'Strategy',
      team: 'Team'
    },
    tr: {
      title: 'Yetenekler',
      development: 'Geliştirme',
      mobile: 'Mobil',
      cloud: 'Bulut',
      ecommerce: 'E-Ticaret',
      marketing: 'Pazarlama',
      seo: 'SEO',
      content: 'İçerik',
      ppc: 'PPC',
      funnels: 'Huniler',
      business: 'İş',
      revenue: 'Gelir',
      market: 'Pazar',
      strategy: 'Strateji',
      team: 'Takım'
    },
    pl: {
      title: 'Umiejętności',
      development: 'Rozwój',
      mobile: 'Mobilne',
      cloud: 'Chmura',
      ecommerce: 'E-commerce',
      marketing: 'Marketing',
      seo: 'SEO',
      content: 'Treść',
      ppc: 'PPC',
      funnels: 'Lejki',
      business: 'Biznes',
      revenue: 'Przychód',
      market: 'Rynek',
      strategy: 'Strategia',
      team: 'Zespół'
    },
    de: {
      title: 'Fähigkeiten',
      development: 'Entwicklung',
      mobile: 'Mobil',
      cloud: 'Cloud',
      ecommerce: 'E-Commerce',
      marketing: 'Marketing',
      seo: 'SEO',
      content: 'Inhalt',
      ppc: 'PPC',
      funnels: 'Funnels',
      business: 'Unternehmen',
      revenue: 'Umsatz',
      market: 'Markt',
      strategy: 'Strategie',
      team: 'Team'
    }
  },
  achievements: {
    en: {
      title: 'Achievements',
      businesstitle: 'Revenue Growth',
      businesstext: 'Achieved significant sales goals.',
      technicaltitle: 'Innovation',
      technicaltext: 'Pioneered new web technologies.',
      leadertitle: 'Excellence',
      leadertext: 'Consistently delivered high quality.'
    },
    tr: {
      title: 'Başarılar',
      businesstitle: 'Gelir Artışı',
      businesstext: 'Önemli satış hedefleri.',
      technicaltitle: 'İnovasyon',
      technicaltext: 'Yeni teknolojiler.',
      leadertitle: 'Mükemmeliyet',
      leadertext: 'Sürekli yüksek kalite.'
    },
    pl: {
      title: 'Osiągnięcia',
      businesstitle: 'Wzrost przychodów',
      businesstext: 'Osiągnięcie celów sprzedażowych.',
      technicaltitle: 'Innowacja',
      technicaltext: 'Nowe technologie webowe.',
      leadertitle: 'Doskonałość',
      leadertext: 'Wysoka jakość'
    },
    de: {
      title: 'Erfolge',
      businesstitle: 'Umsatzwachstum',
      businesstext: 'Wichtige Verkaufsziele.',
      technicaltitle: 'Innovation',
      technicaltext: 'Pionierarbeit.',
      leadertitle: 'Exzellenz',
      leadertext: 'Hohe Qualität.'
    }
  },
  newsletter: {
    en: {
      title: 'Stay in the Loop',
      modalTitle: 'Get Free Updates',
      modalSubtitle: 'Practical insights on tools, tech, and building online. Delivered when it matters.',
      description: 'Join makers who want to work smarter.',
      subtitle: 'Tips and resources for builders. No fluff, just value.',
      growingCommunity: {
        title: 'Growing Community',
        description: 'Join 1,000+ makers and founders.'
      },
      weeklyUpdates: {
        title: 'Weekly Updates',
        description: 'Curated insights straight to your inbox.'
      },
      exclusiveContent: {
        title: 'Exclusive Content',
        description: 'Access resources not shared elsewhere.'
      },
      placeholder: 'Your email address',
      button: 'Join',
      joinButton: 'Get Free Updates',
      trustNoSpam: 'No spam. Just value.',
      trustUnsubscribe: 'Unsubscribe anytime.',
      trustPrivacy: 'Your email stays private.',
      subscribing: 'Joining...',
      success: 'Welcome!',
      successMessage: 'You are in. Check your inbox.',
      error: 'Error',
      errorEmail: 'Please enter a valid email',
      errorGeneral: 'Something went wrong. Try again.'
    },
    tr: {
      title: 'Gelişmelerden Haberdar Ol',
      modalTitle: 'Ücretsiz Güncellemeler Al',
      modalSubtitle: 'Araçlar, teknoloji ve çevrimiçi iş kurma hakkında pratik bilgiler. Önemli olduğunda gönderilir.',
      description: 'Daha akıllı çalışmak isteyen yapımcılara katılın.',
      subtitle: 'Yapımcılar için ipuçları ve kaynaklar. Sadece değer.',
      growingCommunity: {
        title: 'Büyüyen Topluluk',
        description: '1.000\'den fazla yapımcı ve kurucuya katılın.'
      },
      weeklyUpdates: {
        title: 'Haftalık Güncellemeler',
        description: 'Seçilmiş bilgiler doğrudan gelen kutunuza.'
      },
      exclusiveContent: {
        title: 'Özel İçerik',
        description: 'Başka yerde paylaşılmayan kaynaklara erişin.'
      },
      placeholder: 'E-posta adresiniz',
      button: 'Katıl',
      joinButton: 'Ücretsiz Güncelleme Al',
      trustNoSpam: 'Spam yok. Sadece değer.',
      trustUnsubscribe: 'İstediğiniz zaman ayrılın.',
      trustPrivacy: 'E-postanız gizli kalır.',
      subscribing: 'Katılıyorsunuz...',
      success: 'Hoş geldiniz!',
      successMessage: 'İçeridesiniz. Gelen kutunuzu kontrol edin.',
      error: 'Hata',
      errorEmail: 'Lütfen geçerli bir e-posta girin',
      errorGeneral: 'Bir şeyler ters gitti. Tekrar deneyin.'
    },
    pl: {
      title: 'Bądź na Bieżąco',
      modalTitle: 'Otrzymuj Darmowe Aktualizacje',
      modalSubtitle: 'Praktyczne wskazówki dotyczące narzędzi, technologii i budowania online. Dostarczane gdy to ważne.',
      description: 'Dołącz do twórców którzy chcą pracować mądrzej.',
      subtitle: 'Wskazówki i zasoby dla builderów. Bez zbędników, tylko wartość.',
      growingCommunity: {
        title: 'Rosnąca Społeczność',
        description: 'Dołącz do 1000+ twórców i founderów.'
      },
      weeklyUpdates: {
        title: 'Cotygodniowe Aktualizacje',
        description: 'Wyselekcjonowane spostrzeżenia prosto do skrzynki.'
      },
      exclusiveContent: {
        title: 'Ekskluzywne Treści',
        description: 'Dostęp do zasobów niedostępnych gdzie indziej.'
      },
      placeholder: 'Twój adres e-mail',
      button: 'Dołącz',
      joinButton: 'Otrzymuj Darmowe Aktualizacje',
      trustNoSpam: 'Bez spamu. Tylko wartość.',
      trustUnsubscribe: 'Wypisz się kiedy chcesz.',
      trustPrivacy: 'Twój e-mail pozostaje prywatny.',
      subscribing: 'Dołączanie...',
      success: 'Witaj!',
      successMessage: 'Jesteś w środku. Sprawdź skrzynkę.',
      error: 'Błąd',
      errorEmail: 'Wprowadź poprawny e-mail',
      errorGeneral: 'Coś poszło nie tak. Spróbuj ponownie.'
    },
    de: {
      title: 'Bleib Informiert',
      modalTitle: 'Kostenlose Updates Erhalten',
      modalSubtitle: 'Praktische Einblicke zu Tools, Tech und Online-Aufbau. Geliefert wenn es wichtig ist.',
      subtitle: 'Tipps und Ressourcen für Builder. Kein Fluff, nur Wert.',
      description: 'Schließe dich Machern an die smarter arbeiten wollen.',
      growingCommunity: {
        title: 'Wachsende Community',
        description: 'Schließe dich 1.000+ Machern und Gründern an.'
      },
      weeklyUpdates: {
        title: 'Wöchentliche Updates',
        description: 'Kuratierte Einblicke direkt in dein Postfach.'
      },
      exclusiveContent: {
        title: 'Exklusive Inhalte',
        description: 'Zugang zu Ressourcen die anderswo nicht geteilt werden.'
      },
      placeholder: 'Deine E-Mail-Adresse',
      button: 'Beitreten',
      joinButton: 'Kostenlose Updates Erhalten',
      trustNoSpam: 'Kein Spam. Nur Wert.',
      trustUnsubscribe: 'Jederzeit abmelden.',
      trustPrivacy: 'Deine E-Mail bleibt privat.',
      subscribing: 'Beitritt...',
      success: 'Willkommen!',
      successMessage: 'Du bist drin. Check dein Postfach.',
      error: 'Fehler',
      errorEmail: 'Bitte gültige E-Mail eingeben',
      errorGeneral: 'Etwas ging schief. Versuch es nochmal.'
    }
  },
  patreon: {
    en: {
      support: 'Support My Work',
      title: 'Help keep these tools free and growing.',
      recurring: 'per month',
      button: 'Become a Supporter',
      tiers: {
        flame: {
          title: 'Keep the Lights On',
          description: 'Your $1 helps cover hosting costs and keeps free tools running. Small support, real impact.'
        },
        heart: {
          title: 'Fuel Development',
          description: 'At $4.99, you directly fund new features and updates. Be part of what gets built next.'
        },
        crown: {
          title: 'Founding Supporter',
          description: 'For under $10, get early access to new tools, plus a personal thank you and priority input on features.'
        }
      }
    },
    tr: {
      support: 'Çalışmalarımı Destekle',
      title: 'Bu araçları ücretsiz ve büyüyen tutmama yardım edin.',
      recurring: 'aylık',
      button: 'Destekçi Ol',
      tiers: {
        flame: {
          title: 'Işıkları Açık Tut',
          description: '1$ barındırma maliyetlerini karşılamaya ve ücretsiz araçların çalışmasını sağlamaya yardımcı olur.'
        },
        heart: {
          title: 'Geliştirmeyi Yakıtla',
          description: '4.99$ ile yeni özellikleri ve güncellemeleri doğrudan fonlarsınız.'
        },
        crown: {
          title: 'Kurucu Destekçi',
          description: '10$ altında yeni araçlara erken erişim ve özellik önerilerinde öncelik kazanın.'
        }
      }
    },
    pl: {
      support: 'Wesprzyj Moją Pracę',
      title: 'Pomóż utrzymać te narzędzia darmowe i rozwijające się.',
      recurring: 'miesięcznie',
      button: 'Zostań Wspierającym',
      tiers: {
        flame: {
          title: 'Utrzymaj Światło',
          description: 'Twoje $1 pokrywa koszty hostingu i utrzymuje darmowe narzędzia. Małe wsparcie, prawdziwy wpływ.'
        },
        heart: {
          title: 'Napędzaj Rozwój',
          description: 'Za $4.99 bezpośrednio fundujesz nowe funkcje i aktualizacje.'
        },
        crown: {
          title: 'Wspierający Założyciel',
          description: 'Za mniej niż $10 uzyskaj wczesny dostęp do nowych narzędzi i priorytet w sugestiach.'
        }
      }
    },
    de: {
      support: 'Unterstütze Meine Arbeit',
      title: 'Hilf diese Tools kostenlos und wachsend zu halten.',
      recurring: 'pro Monat',
      button: 'Unterstützer Werden',
      tiers: {
        flame: {
          title: 'Halte das Licht An',
          description: 'Dein $1 deckt Hosting-Kosten und hält kostenlose Tools am Laufen.'
        },
        heart: {
          title: 'Treibe Entwicklung An',
          description: 'Mit $4.99 finanzierst du direkt neue Features und Updates.'
        },
        crown: {
          title: 'Gründungs-Unterstützer',
          description: 'Für unter $10 erhalte frühen Zugang zu neuen Tools und Priorität bei Feature-Wünschen.'
        }
      }
    }
  },
  promo: {
    en: {
      cta_title: 'Ready to Work Smarter?',
      cta_subtitle: 'Explore the tools and resources I built to save you time.',
      cta_button: 'Explore Products',
      cta_banner: 'Built for Makers',
      cta_banner_subtitle: 'Simple tools that solve real problems. No fluff.'
    },
    tr: {
      cta_title: 'Daha Akıllı Çalışmaya Hazır mısınız?',
      cta_subtitle: 'Size zaman kazandırmak için oluşturduğum araçları ve kaynakları keşfedin.',
      cta_button: 'Ürünleri Keşfet',
      cta_banner: 'Yapımcılar için Yapıldı',
      cta_banner_subtitle: 'Gerçek sorunları çözen basit araçlar. Gereksiz şeyler yok.'
    },
    pl: {
      cta_title: 'Gotowy Pracować Mądrzej?',
      cta_subtitle: 'Odkryj narzędzia i zasoby które stworzyłem aby zaoszczędzić Twój czas.',
      cta_button: 'Odkryj Produkty',
      cta_banner: 'Stworzone dla Twórców',
      cta_banner_subtitle: 'Proste narzędzia rozwiązujące prawdziwe problemy. Bez zbędników.'
    },
    de: {
      cta_title: 'Bereit Smarter zu Arbeiten?',
      cta_subtitle: 'Entdecke die Tools und Ressourcen die ich gebaut habe um dir Zeit zu sparen.',
      cta_button: 'Produkte Entdecken',
      cta_banner: 'Für Macher Gebaut',
      cta_banner_subtitle: 'Einfache Tools die echte Probleme lösen. Kein Schnickschnack.'
    }
  },
  footer: {
    en: {
      madeWith: 'Built with',
      rights: 'All rights reserved',
      support: 'Support',
      followMe: 'Connect',
      resources: 'Explore',
      store: 'Store',
      consultation: 'Book a Call',
      privacy: 'Privacy',
      terms: 'Terms',
      cookies: 'Cookies',
      quickLinks: 'Quick Links'
    },
    tr: {
      madeWith: 'Yapıldı',
      rights: 'Tüm hakları saklıdır',
      support: 'Destek',
      followMe: 'Bağlan',
      resources: 'Keşfet',
      store: 'Mağaza',
      consultation: 'Görüşme Ayarla',
      privacy: 'Gizlilik',
      terms: 'Şartlar',
      cookies: 'Çerezler',
      quickLinks: 'Hızlı Bağlantılar'
    },
    pl: {
      madeWith: 'Zbudowane z',
      rights: 'Wszelkie prawa zastrzeżone',
      support: 'Wsparcie',
      followMe: 'Połącz',
      resources: 'Odkryj',
      store: 'Sklep',
      consultation: 'Umów Rozmowę',
      privacy: 'Prywatność',
      terms: 'Regulamin',
      cookies: 'Ciasteczka',
      quickLinks: 'Szybkie Linki'
    },
    de: {
      madeWith: 'Gebaut mit',
      rights: 'Alle Rechte vorbehalten',
      support: 'Support',
      followMe: 'Verbinden',
      resources: 'Entdecken',
      store: 'Shop',
      consultation: 'Call Buchen',
      privacy: 'Datenschutz',
      terms: 'AGB',
      cookies: 'Cookies',
      quickLinks: 'Quick Links'
    }
  },
  blog: {
    en: {
      sectionTitle: 'From the Blog',
      sectionSubtitle: 'Practical ideas on building, selling, and shipping.',
      viewAll: 'Read all posts',
      readMore: 'Read',
      errorTitle: 'Blog unavailable',
      errorMsg: 'Unable to load posts right now.'
    },
    tr: {
      sectionTitle: 'Blogdan',
      sectionSubtitle: 'Yapma, satma ve gönderme hakkında pratik fikirler.',
      viewAll: 'Tüm yazıları oku',
      readMore: 'Oku',
      errorTitle: 'Blog kullanılamıyor',
      errorMsg: 'Yazılar şu anda yüklenemiyor.'
    },
    pl: {
      sectionTitle: 'Z Bloga',
      sectionSubtitle: 'Praktyczne pomysły na budowanie, sprzedawanie i dostarczanie.',
      viewAll: 'Czytaj wszystkie',
      readMore: 'Czytaj',
      errorTitle: 'Blog niedostępny',
      errorMsg: 'Nie można załadować postów.'
    },
    de: {
      sectionTitle: 'Aus dem Blog',
      sectionSubtitle: 'Praktische Ideen zum Bauen, Verkaufen und Liefern.',
      viewAll: 'Alle lesen',
      readMore: 'Lesen',
      errorTitle: 'Blog nicht verfügbar',
      errorMsg: 'Posts können nicht geladen werden.'
    }
  },
  tools: {
    en: {
      title: 'Tools I Recommend',
      subtitle: 'The services I use daily to build and run my projects. Tried, tested, trusted.',
      affiliateNotice: 'Some links are affiliate links. Using them supports my work at no extra cost to you.',
      searchPlaceholder: 'Search tools...',
      all: 'All',
      learnMore: 'Try it'
    },
    tr: {
      title: 'Önerdiğim Araçlar',
      subtitle: 'Projelerimi oluşturmak ve yönetmek için günlük kullandığım hizmetler. Denenmiş, test edilmiş, güvenilir.',
      affiliateNotice: 'Bazı bağlantılar ortaklık bağlantılarıdır. Kullanmak size ekstra maliyet olmadan çalışmamı destekler.',
      searchPlaceholder: 'Araç ara...',
      all: 'Hepsi',
      learnMore: 'Dene'
    },
    pl: {
      title: 'Narzędzia Które Polecam',
      subtitle: 'Usługi których używam codziennie do budowania i prowadzenia projektów. Sprawdzone i zaufane.',
      affiliateNotice: 'Niektóre linki to linki afiliacyjne. Korzystanie z nich wspiera moją pracę bez dodatkowych kosztów.',
      searchPlaceholder: 'Szukaj narzędzi...',
      all: 'Wszystkie',
      learnMore: 'Wypróbuj'
    },
    de: {
      title: 'Tools Die Ich Empfehle',
      subtitle: 'Die Services die ich täglich nutze um meine Projekte zu bauen und zu betreiben. Getestet und vertraut.',
      affiliateNotice: 'Einige Links sind Affiliate-Links. Die Nutzung unterstützt meine Arbeit ohne Extrakosten für dich.',
      searchPlaceholder: 'Tools suchen...',
      all: 'Alle',
      learnMore: 'Ausprobieren'
    }
  },
  consultation: {
    en: {
      badge: 'Personal Guidance',
      title: 'Work With Me Directly',
      subtitle: 'Get clarity on your e-commerce strategy in a focused 1-on-1 session.',
      recommended: 'Most Booked',
      allegroTitle: 'Allegro Strategy Session',
      allegroDescription: 'A focused hour to review your Allegro business, identify opportunities, and create an action plan.',
      minutes: 'min',
      oneTime: 'one-time',
      feature1: 'Review your current strategy',
      feature2: 'Optimize your listings',
      feature3: 'Understand your competition',
      feature4: 'Plan your next steps',
      feature5: 'Get your questions answered',
      scheduleButton: 'Book a Session',
      expectTitle: 'How It Works',
      videoTitle: 'Video Call',
      videoDesc: 'We meet via Google Meet for a focused conversation.',
      flexibleTitle: 'Your Schedule',
      flexibleDesc: 'Pick a time that works for you.',
      personalTitle: 'Your Questions',
      personalDesc: 'Come prepared with your challenges.',
      trustSecure: 'Secure booking',
      trustGuarantee: 'Helpful or your money back'
    },
    tr: {
      badge: 'Kişisel Rehberlik',
      title: 'Benimle Doğrudan Çalışın',
      subtitle: 'Odaklı bir 1-1 oturumda e-ticaret stratejiniz hakkında netlik kazanın.',
      recommended: 'En Çok Tercih Edilen',
      allegroTitle: 'Allegro Strateji Oturumu',
      allegroDescription: 'Allegro işinizi incelemek, fırsatları belirlemek ve bir eylem planı oluşturmak için odaklı bir saat.',
      minutes: 'dk',
      oneTime: 'tek seferlik',
      feature1: 'Mevcut stratejinizi inceleyin',
      feature2: 'Listelerinizi optimize edin',
      feature3: 'Rekabeti anlayın',
      feature4: 'Sonraki adımlarınızı planlayın',
      feature5: 'Sorularınızı yanıtlayın',
      scheduleButton: 'Oturum Ayırın',
      expectTitle: 'Nasıl Çalışır',
      videoTitle: 'Görüntülü Arama',
      videoDesc: 'Odaklı bir görüşme için Google Meet üzerinden buluşuyoruz.',
      flexibleTitle: 'Sizin Programınız',
      flexibleDesc: 'Size uygun bir zaman seçin.',
      personalTitle: 'Sizin Sorularınız',
      personalDesc: 'Zorluklarınızla hazırlıklı gelin.',
      trustSecure: 'Güvenli rezervasyon',
      trustGuarantee: 'Faydalı yoksa paranız iade'
    },
    pl: {
      badge: 'Osobiste Wsparcie',
      title: 'Pracuj ze Mną Bezpośrednio',
      subtitle: 'Uzyskaj jasność w strategii e-commerce podczas skoncentrowanej sesji 1-na-1.',
      recommended: 'Najczęściej Rezerwowane',
      allegroTitle: 'Sesja Strategiczna Allegro',
      allegroDescription: 'Skupiona godzina na przegląd Twojego biznesu na Allegro, identyfikację szans i stworzenie planu działania.',
      minutes: 'min',
      oneTime: 'jednorazowo',
      feature1: 'Przegląd obecnej strategii',
      feature2: 'Optymalizacja ofert',
      feature3: 'Zrozumienie konkurencji',
      feature4: 'Plan kolejnych kroków',
      feature5: 'Odpowiedzi na pytania',
      scheduleButton: 'Zarezerwuj Sesję',
      expectTitle: 'Jak To Działa',
      videoTitle: 'Rozmowa Wideo',
      videoDesc: 'Spotykamy się przez Google Meet na skoncentrowaną rozmowę.',
      flexibleTitle: 'Twój Harmonogram',
      flexibleDesc: 'Wybierz czas który Ci odpowiada.',
      personalTitle: 'Twoje Pytania',
      personalDesc: 'Przyjdź przygotowany ze swoimi wyzwaniami.',
      trustSecure: 'Bezpieczna rezerwacja',
      trustGuarantee: 'Pomocne lub zwrot pieniędzy'
    },
    de: {
      badge: 'Persönliche Begleitung',
      title: 'Arbeite Direkt Mit Mir',
      subtitle: 'Erhalte Klarheit über deine E-Commerce-Strategie in einer fokussierten 1-zu-1 Session.',
      recommended: 'Am Meisten Gebucht',
      allegroTitle: 'Allegro Strategie-Session',
      allegroDescription: 'Eine fokussierte Stunde um dein Allegro-Business zu reviewen, Chancen zu identifizieren und einen Aktionsplan zu erstellen.',
      minutes: 'Min',
      oneTime: 'einmalig',
      feature1: 'Review deiner aktuellen Strategie',
      feature2: 'Optimierung deiner Listings',
      feature3: 'Verständnis der Konkurrenz',
      feature4: 'Planung der nächsten Schritte',
      feature5: 'Beantwortung deiner Fragen',
      scheduleButton: 'Session Buchen',
      expectTitle: 'So Funktioniert Es',
      videoTitle: 'Video-Call',
      videoDesc: 'Wir treffen uns via Google Meet für ein fokussiertes Gespräch.',
      flexibleTitle: 'Dein Zeitplan',
      flexibleDesc: 'Wähle eine Zeit die für dich passt.',
      personalTitle: 'Deine Fragen',
      personalDesc: 'Komm vorbereitet mit deinen Herausforderungen.',
      trustSecure: 'Sichere Buchung',
      trustGuarantee: 'Hilfreich oder Geld zurück'
    }
  },
  phonetic: {
    en: {
      navHome: 'Home',
      navFeatures: 'Features',
      navPricing: 'Pricing',
      navDownload: 'Download',
      navDemo: 'Demo',
      navSupport: 'Support',
      navInstallFree: 'Install Free',
      heroBadge: 'Free Chrome Extension',
      heroTitle: 'Transform Text with Phonetic Precision',
      heroSubtitle: 'The easiest way to convert text to multiple phonetic alphabets in real-time. Used by linguists, teachers, and professionals worldwide.',
      heroGetStarted: 'Get Started',
      heroLearnMore: 'Learn More',
      heroInstallChrome: 'Install for Chrome — Free',
      heroWatchDemo: 'Watch Demo',
      trustRating: '5.0 ★ Chrome Store',
      trustUsers: '1,000+ Active Users',
      trustFeatured: 'Featured Extension',
      trustPrivate: '100% Free & Private',
      featuresSectionTitle: 'Why Choose PhoneticPro?',
      featuresSubtitle: 'Powerful tools designed for language professionals, students, and enthusiasts.',
      featureMultipleAlphabetsTitle: 'Multiple Phonetic Alphabets',
      featureMultipleAlphabetsDesc: 'Support for IPA, NATO, and more international standards.',
      featureRealtimeTitle: 'Real-time Conversion',
      featureRealtimeDesc: 'Convert text instantly as you type with zero delay.',
      featureIPATitle: 'IPA Pronunciation Guides',
      featureIPADesc: 'Comprehensive pronunciation guides for every symbol.',
      featureThemeTitle: 'Dark & Light Theme',
      featureThemeDesc: 'Choose your preferred visual style for comfortable use.',
      downloadTitle: 'Available for All Browsers',
      downloadSubtitle: 'Download for free and start converting text instantly.',
      downloadChrome: 'Get for Chrome',
      downloadFirefox: 'Get for Firefox',
      downloadEdge: 'Get for Edge',
      downloadOpera: 'Get for Opera',
      downloadSafari: 'Get for Safari',
      comingSoon: 'Coming Soon',
      demoTitle: 'Try It Now',
      demoSubtitle: 'Experience the conversion in action — no installation required.',
      demoTryIt: 'Convert',
      demoInputLabel: 'Enter your text',
      demoInputPlaceholder: 'Type something like "Hello World"...',
      demoOutputLabel: 'Phonetic Result',
      demoSelectAlphabet: 'Select Alphabet',
      demoCopy: 'Copy',
      demoCopied: 'Copied!',
      testimonialsSectionTitle: 'Loved by Professionals',
      testimonialsSubtitle: 'See what our users are saying about PhoneticPro.',
      testimonial1Name: 'Sarah Johnson',
      testimonial1Role: 'Language Teacher',
      testimonial1Content: 'This extension has transformed how I teach phonetics to my students. The real-time conversion and pronunciation guides are invaluable tools in my classroom.',
      testimonial2Name: 'David Chen',
      testimonial2Role: 'Linguistics Student',
      testimonial2Content: 'As someone studying linguistics, I use this extension daily. The multiple phonetic alphabet support is exactly what I needed for my research.',
      testimonial3Name: 'Emily Clark',
      testimonial3Role: 'Speech Therapist',
      testimonial3Content: 'The IPA guides in this extension help my patients understand proper pronunciation. It has become an essential tool in my practice.',
      supportTitle: 'Support Development',
      supportSubtitle: 'Help us keep PhoneticPro free and continuously improving.',
      supportThankYouMessage: 'PhoneticPro is free and open-source. If you find it useful, consider supporting the development to help us add new features and maintain the extension.',
      supportPatreon: 'Support on Patreon',
      supportBuyMeACoffee: 'Buy Me A Coffee',
      supportThankYou: 'Thank you!',
      footerRights: 'All Rights Reserved',
      footerPrivacy: 'Privacy Policy',
      footerTerms: 'Terms of Service',
      privacyPolicySubtitle: 'Your privacy is important to us.'
    },
    tr: {
      navHome: 'Ana Sayfa',
      navFeatures: 'Özellikler',
      navPricing: 'Fiyatlar',
      navDownload: 'İndir',
      navDemo: 'Demo',
      navSupport: 'Destek',
      navInstallFree: 'Ücretsiz Yükle',
      heroBadge: 'Ücretsiz Chrome Uzantısı',
      heroTitle: 'Metni Fonetik Hassasiyetle Dönüştürün',
      heroSubtitle: 'Metni gerçek zamanlı olarak birden fazla fonetik alfabeye dönüştürmenin en kolay yolu. Dilbilimciler, öğretmenler ve profesyoneller tarafından kullanılır.',
      heroGetStarted: 'Başla',
      heroLearnMore: 'Daha Fazla',
      heroInstallChrome: 'Chrome için Yükle — Ücretsiz',
      heroWatchDemo: 'Demo İzle',
      trustRating: '5.0 ★ Chrome Mağaza',
      trustUsers: '1.000+ Aktif Kullanıcı',
      trustFeatured: 'Öne Çıkan Uzantı',
      trustPrivate: '%100 Ücretsiz ve Gizli',
      featuresSectionTitle: 'Neden PhoneticPro?',
      featuresSubtitle: 'Dil profesyonelleri, öğrenciler ve meraklılar için tasarlanmış güçlü araçlar.',
      featureMultipleAlphabetsTitle: 'Çoklu Fonetik Alfabe',
      featureMultipleAlphabetsDesc: 'IPA, NATO ve daha fazla uluslararası standart desteği.',
      featureRealtimeTitle: 'Gerçek Zamanlı Dönüşüm',
      featureRealtimeDesc: 'Yazarken anında metin dönüştürme.',
      featureIPATitle: 'IPA Telaffuz Rehberleri',
      featureIPADesc: 'Her sembol için kapsamlı telaffuz rehberleri.',
      featureThemeTitle: 'Karanlık ve Aydınlık Tema',
      featureThemeDesc: 'Rahat kullanım için tercih ettiğiniz görsel stili seçin.',
      downloadTitle: 'Tüm Tarayıcılarda Mevcut',
      downloadSubtitle: 'Ücretsiz indirin ve hemen dönüştürmeye başlayın.',
      downloadChrome: 'Chrome için',
      downloadFirefox: 'Firefox için',
      downloadEdge: 'Edge için',
      downloadOpera: 'Opera için',
      downloadSafari: 'Safari için',
      comingSoon: 'Yakında',
      demoTitle: 'Şimdi Deneyin',
      demoSubtitle: 'Dönüşümü canlı deneyimleyin — kurulum gerekmez.',
      demoTryIt: 'Dönüştür',
      demoInputLabel: 'Metninizi girin',
      demoInputPlaceholder: '"Merhaba Dünya" gibi bir şey yazın...',
      demoOutputLabel: 'Fonetik Sonuç',
      demoSelectAlphabet: 'Alfabe Seç',
      demoCopy: 'Kopyala',
      demoCopied: 'Kopyalandı!',
      testimonialsSectionTitle: 'Profesyoneller Tarafından Seviliyor',
      testimonialsSubtitle: 'Kullanıcılarımızın PhoneticPro hakkında söylediklerini görün.',
      testimonial1Name: 'Ayşe Yılmaz',
      testimonial1Role: 'Dil Öğretmeni',
      testimonial1Content: 'Bu uzantı, öğrencilerime fonetik öğretme şeklimi değiştirdi. Gerçek zamanlı dönüşüm ve telaffuz rehberleri sınıfımda paha biçilmez araçlar.',
      testimonial2Name: 'Mehmet Kaya',
      testimonial2Role: 'Dilbilim Öğrencisi',
      testimonial2Content: 'Dilbilim okuyan biri olarak bu uzantıyı her gün kullanıyorum. Çoklu fonetik alfabe desteği araştırmam için tam olarak ihtiyacım olan şeydi.',
      testimonial3Name: 'Zeynep Demir',
      testimonial3Role: 'Konuşma Terapisti',
      testimonial3Content: 'Bu uzantıdaki IPA rehberleri hastalarımın doğru telaffuzu anlamalarına yardımcı oluyor. Pratiğimde vazgeçilmez bir araç haline geldi.',
      supportTitle: 'Geliştirmeyi Destekle',
      supportSubtitle: 'PhoneticPro\'yu ücretsiz ve sürekli gelişen tutmamıza yardımcı olun.',
      supportThankYouMessage: 'PhoneticPro ücretsiz ve açık kaynaklıdır. Yararlı bulursanız, yeni özellikler eklememize ve uzantıyı sürdürmemize yardımcı olmak için geliştirmeyi desteklemeyi düşünün.',
      supportPatreon: 'Patreon\'da Destekle',
      supportBuyMeACoffee: 'Kahve Ismarla',
      supportThankYou: 'Teşekkürler!',
      footerRights: 'Tüm Hakları Saklıdır',
      footerPrivacy: 'Gizlilik Politikası',
      footerTerms: 'Kullanım Şartları',
      privacyPolicySubtitle: 'Gizliliğiniz bizim için önemlidir.'
    },
    pl: {
      navHome: 'Strona główna',
      navFeatures: 'Funkcje',
      navPricing: 'Cennik',
      navDownload: 'Pobierz',
      navDemo: 'Demo',
      navSupport: 'Wsparcie',
      navInstallFree: 'Zainstaluj za darmo',
      heroBadge: 'Darmowe rozszerzenie Chrome',
      heroTitle: 'Przekształcaj Tekst z Fonetyczną Precyzją',
      heroSubtitle: 'Najprostszy sposób na konwersję tekstu do wielu alfabetów fonetycznych w czasie rzeczywistym. Używany przez lingwistów, nauczycieli i profesjonalistów.',
      heroGetStarted: 'Rozpocznij',
      heroLearnMore: 'Dowiedz się więcej',
      heroInstallChrome: 'Zainstaluj dla Chrome — Za darmo',
      heroWatchDemo: 'Zobacz Demo',
      trustRating: '5.0 ★ Chrome Store',
      trustUsers: '1000+ Aktywnych użytkowników',
      trustFeatured: 'Wyróżnione rozszerzenie',
      trustPrivate: '100% Darmowe i Prywatne',
      featuresSectionTitle: 'Dlaczego PhoneticPro?',
      featuresSubtitle: 'Potężne narzędzia zaprojektowane dla profesjonalistów językowych, studentów i entuzjastów.',
      featureMultipleAlphabetsTitle: 'Wiele Alfabetów Fonetycznych',
      featureMultipleAlphabetsDesc: 'Obsługa IPA, NATO i innych międzynarodowych standardów.',
      featureRealtimeTitle: 'Konwersja w czasie rzeczywistym',
      featureRealtimeDesc: 'Konwertuj tekst natychmiast podczas pisania.',
      featureIPATitle: 'Przewodniki wymowy IPA',
      featureIPADesc: 'Kompleksowe przewodniki wymowy dla każdego symbolu.',
      featureThemeTitle: 'Ciemny i Jasny Motyw',
      featureThemeDesc: 'Wybierz preferowany styl wizualny dla komfortowego użytkowania.',
      downloadTitle: 'Dostępne dla wszystkich przeglądarek',
      downloadSubtitle: 'Pobierz za darmo i natychmiast zacznij konwertować tekst.',
      downloadChrome: 'Dla Chrome',
      downloadFirefox: 'Dla Firefox',
      downloadEdge: 'Dla Edge',
      downloadOpera: 'Dla Opera',
      downloadSafari: 'Dla Safari',
      comingSoon: 'Wkrótce',
      demoTitle: 'Wypróbuj Teraz',
      demoSubtitle: 'Doświadcz konwersji w akcji — instalacja nie jest wymagana.',
      demoTryIt: 'Konwertuj',
      demoInputLabel: 'Wprowadź swój tekst',
      demoInputPlaceholder: 'Wpisz coś jak "Witaj Świecie"...',
      demoOutputLabel: 'Wynik Fonetyczny',
      demoSelectAlphabet: 'Wybierz alfabet',
      demoCopy: 'Kopiuj',
      demoCopied: 'Skopiowano!',
      testimonialsSectionTitle: 'Kochany przez Profesjonalistów',
      testimonialsSubtitle: 'Zobacz, co mówią nasi użytkownicy o PhoneticPro.',
      testimonial1Name: 'Anna Kowalska',
      testimonial1Role: 'Nauczycielka Języków',
      testimonial1Content: 'To rozszerzenie zmieniło sposób, w jaki uczę fonetyki moich uczniów. Konwersja w czasie rzeczywistym i przewodniki wymowy są nieocenionymi narzędziami w mojej klasie.',
      testimonial2Name: 'Piotr Nowak',
      testimonial2Role: 'Student Językoznawstwa',
      testimonial2Content: 'Jako osoba studiująca językoznawstwo, używam tego rozszerzenia codziennie. Obsługa wielu alfabetów fonetycznych jest dokładnie tym, czego potrzebowałem do moich badań.',
      testimonial3Name: 'Katarzyna Wiśniewska',
      testimonial3Role: 'Logopeda',
      testimonial3Content: 'Przewodniki IPA w tym rozszerzeniu pomagają moim pacjentom zrozumieć prawidłową wymowę. Stało się niezbędnym narzędziem w mojej praktyce.',
      supportTitle: 'Wesprzyj Rozwój',
      supportSubtitle: 'Pomóż nam utrzymać PhoneticPro darmowym i stale rozwijającym się.',
      supportThankYouMessage: 'PhoneticPro jest darmowy i open-source. Jeśli uważasz go za przydatny, rozważ wsparcie rozwoju, aby pomóc nam dodawać nowe funkcje i utrzymywać rozszerzenie.',
      supportPatreon: 'Wesprzyj na Patreon',
      supportBuyMeACoffee: 'Kup mi kawę',
      supportThankYou: 'Dziękujemy!',
      footerRights: 'Wszelkie prawa zastrzeżone',
      footerPrivacy: 'Polityka prywatności',
      footerTerms: 'Warunki serwisu',
      privacyPolicySubtitle: 'Twoja prywatność jest dla nas ważna.'
    },
    de: {
      navHome: 'Startseite',
      navFeatures: 'Funktionen',
      navPricing: 'Preise',
      navDownload: 'Herunterladen',
      navDemo: 'Demo',
      navSupport: 'Unterstützung',
      navInstallFree: 'Kostenlos installieren',
      heroBadge: 'Kostenlose Chrome-Erweiterung',
      heroTitle: 'Text mit phonetischer Präzision umwandeln',
      heroSubtitle: 'Der einfachste Weg, Text in Echtzeit in mehrere phonetische Alphabete umzuwandeln. Verwendet von Linguisten, Lehrern und Fachleuten weltweit.',
      heroGetStarted: 'Loslegen',
      heroLearnMore: 'Mehr erfahren',
      heroInstallChrome: 'Für Chrome installieren — Kostenlos',
      heroWatchDemo: 'Demo ansehen',
      trustRating: '5.0 ★ Chrome Store',
      trustUsers: '1.000+ Aktive Nutzer',
      trustFeatured: 'Empfohlene Erweiterung',
      trustPrivate: '100% Kostenlos & Privat',
      featuresSectionTitle: 'Warum PhoneticPro?',
      featuresSubtitle: 'Leistungsstarke Tools für Sprachprofis, Studenten und Enthusiasten.',
      featureMultipleAlphabetsTitle: 'Mehrere phonetische Alphabete',
      featureMultipleAlphabetsDesc: 'Unterstützung für IPA, NATO und weitere internationale Standards.',
      featureRealtimeTitle: 'Echtzeit-Konvertierung',
      featureRealtimeDesc: 'Text sofort während der Eingabe umwandeln.',
      featureIPATitle: 'IPA-Ausspracheführer',
      featureIPADesc: 'Umfassende Ausspracheführer für jedes Symbol.',
      featureThemeTitle: 'Dunkles & Helles Theme',
      featureThemeDesc: 'Wählen Sie Ihren bevorzugten visuellen Stil für komfortable Nutzung.',
      downloadTitle: 'Für alle Browser verfügbar',
      downloadSubtitle: 'Kostenlos herunterladen und sofort mit der Textkonvertierung beginnen.',
      downloadChrome: 'Für Chrome',
      downloadFirefox: 'Für Firefox',
      downloadEdge: 'Für Edge',
      downloadOpera: 'Für Opera',
      downloadSafari: 'Für Safari',
      comingSoon: 'Bald verfügbar',
      demoTitle: 'Jetzt ausprobieren',
      demoSubtitle: 'Erleben Sie die Konvertierung in Aktion — keine Installation erforderlich.',
      demoTryIt: 'Umwandeln',
      demoInputLabel: 'Geben Sie Ihren Text ein',
      demoInputPlaceholder: 'Tippen Sie etwas wie "Hallo Welt"...',
      demoOutputLabel: 'Phonetisches Ergebnis',
      demoSelectAlphabet: 'Alphabet wählen',
      demoCopy: 'Kopieren',
      demoCopied: 'Kopiert!',
      testimonialsSectionTitle: 'Von Profis geliebt',
      testimonialsSubtitle: 'Sehen Sie, was unsere Nutzer über PhoneticPro sagen.',
      testimonial1Name: 'Maria Schmidt',
      testimonial1Role: 'Sprachlehrerin',
      testimonial1Content: 'Diese Erweiterung hat die Art und Weise, wie ich meinen Schülern Phonetik beibringe, verändert. Die Echtzeit-Konvertierung und Ausspracheführer sind unschätzbare Werkzeuge in meinem Unterricht.',
      testimonial2Name: 'Thomas Müller',
      testimonial2Role: 'Linguistik-Student',
      testimonial2Content: 'Als jemand, der Linguistik studiert, nutze ich diese Erweiterung täglich. Die Unterstützung mehrerer phonetischer Alphabete ist genau das, was ich für meine Forschung brauchte.',
      testimonial3Name: 'Lisa Weber',
      testimonial3Role: 'Logopädin',
      testimonial3Content: 'Die IPA-Anleitungen in dieser Erweiterung helfen meinen Patienten, die richtige Aussprache zu verstehen. Sie ist zu einem unverzichtbaren Werkzeug in meiner Praxis geworden.',
      supportTitle: 'Entwicklung unterstützen',
      supportSubtitle: 'Helfen Sie uns, PhoneticPro kostenlos und kontinuierlich zu verbessern.',
      supportThankYouMessage: 'PhoneticPro ist kostenlos und Open-Source. Wenn Sie es nützlich finden, unterstützen Sie die Entwicklung, um uns zu helfen, neue Funktionen hinzuzufügen und die Erweiterung zu pflegen.',
      supportPatreon: 'Auf Patreon unterstützen',
      supportBuyMeACoffee: 'Kaffee spendieren',
      supportThankYou: 'Danke!',
      footerRights: 'Alle Rechte vorbehalten',
      footerPrivacy: 'Datenschutz',
      footerTerms: 'AGB',
      privacyPolicySubtitle: 'Ihre Privatsphäre ist uns wichtig.'
    }
  },
  contact: {
    en: {
      title: 'Say Hello',
      subtitle: 'Got a question or idea? Drop me a message.',
      infoTitle: 'Contact',
      email: 'Email',
      location: 'Location',
      locationValue: 'Warsaw, Poland',
      phone: 'Phone',
      phoneValue: 'Available after first contact',
      officeHours: 'Hours',
      mondayFriday: 'Mon - Fri',
      saturday: 'Sat',
      byAppointment: 'By appointment',
      sunday: 'Sun',
      closed: 'Closed',
      sendTitle: 'Send a Message',
      nameLabel: 'Name',
      namePlaceholder: 'Your name',
      emailLabel: 'Email',
      emailPlaceholder: 'you@example.com',
      phoneLabel: 'Phone (Optional)',
      subjectLabel: 'Subject',
      subjectPlaceholder: 'How can I help?',
      messageLabel: 'Message',
      messagePlaceholder: 'Tell me about your project or question...',
      sendButton: 'Send',
      sending: 'Sending...',
      required: 'is required',
      invalidEmail: 'Invalid email',
      successMessage: 'Message sent. I will get back to you soon.',
      captchaError: 'Please complete the verification'
    },
    tr: {
      title: 'Merhaba Deyin',
      subtitle: 'Bir sorunuz veya fikriniz mi var? Bana bir mesaj bırakın.',
      infoTitle: 'İletişim',
      email: 'E-posta',
      location: 'Konum',
      locationValue: 'Varşova, Polonya',
      phone: 'Telefon',
      phoneValue: 'İlk iletişimden sonra mevcut',
      officeHours: 'Saatler',
      mondayFriday: 'Pzt - Cum',
      saturday: 'Cmt',
      byAppointment: 'Randevu ile',
      sunday: 'Paz',
      closed: 'Kapalı',
      sendTitle: 'Mesaj Gönder',
      nameLabel: 'İsim',
      namePlaceholder: 'Adınız',
      emailLabel: 'E-posta',
      emailPlaceholder: 'siz@ornek.com',
      phoneLabel: 'Telefon (İsteğe bağlı)',
      subjectLabel: 'Konu',
      subjectPlaceholder: 'Size nasıl yardımcı olabilirim?',
      messageLabel: 'Mesaj',
      messagePlaceholder: 'Projenizi veya sorunuzu anlatın...',
      sendButton: 'Gönder',
      sending: 'Gönderiliyor...',
      required: 'gereklidir',
      invalidEmail: 'Geçersiz e-posta',
      successMessage: 'Mesaj gönderildi. Yakında size döneceğim.',
      captchaError: 'Doğrulamayı tamamlayın'
    },
    pl: {
      title: 'Powiedz Cześć',
      subtitle: 'Masz pytanie lub pomysł? Zostaw mi wiadomość.',
      infoTitle: 'Kontakt',
      email: 'E-mail',
      location: 'Lokalizacja',
      locationValue: 'Warszawa, Polska',
      phone: 'Telefon',
      phoneValue: 'Dostępny po pierwszym kontakcie',
      officeHours: 'Godziny',
      mondayFriday: 'Pon - Pt',
      saturday: 'Sob',
      byAppointment: 'Po umówieniu',
      sunday: 'Nd',
      closed: 'Zamknięte',
      sendTitle: 'Wyślij Wiadomość',
      nameLabel: 'Imię',
      namePlaceholder: 'Twoje imię',
      emailLabel: 'E-mail',
      emailPlaceholder: 'ty@przyklad.com',
      phoneLabel: 'Telefon (Opcjonalnie)',
      subjectLabel: 'Temat',
      subjectPlaceholder: 'Jak mogę pomóc?',
      messageLabel: 'Wiadomość',
      messagePlaceholder: 'Opowiedz o swoim projekcie lub pytaniu...',
      sendButton: 'Wyślij',
      sending: 'Wysyłanie...',
      required: 'jest wymagane',
      invalidEmail: 'Niepoprawny e-mail',
      successMessage: 'Wiadomość wysłana. Wkrótce się odezwę.',
      captchaError: 'Ukończ weryfikację'
    },
    de: {
      title: 'Sag Hallo',
      subtitle: 'Hast du eine Frage oder Idee? Schreib mir eine Nachricht.',
      infoTitle: 'Kontakt',
      email: 'E-Mail',
      location: 'Standort',
      locationValue: 'Warschau, Polen',
      phone: 'Telefon',
      phoneValue: 'Nach Erstkontakt verfügbar',
      officeHours: 'Zeiten',
      mondayFriday: 'Mo - Fr',
      saturday: 'Sa',
      byAppointment: 'Nach Vereinbarung',
      sunday: 'So',
      closed: 'Geschlossen',
      sendTitle: 'Nachricht Senden',
      nameLabel: 'Name',
      namePlaceholder: 'Dein Name',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'du@beispiel.de',
      phoneLabel: 'Telefon (Optional)',
      subjectLabel: 'Betreff',
      subjectPlaceholder: 'Wie kann ich helfen?',
      messageLabel: 'Nachricht',
      messagePlaceholder: 'Erzähl mir von deinem Projekt oder deiner Frage...',
      sendButton: 'Senden',
      sending: 'Wird gesendet...',
      required: 'ist erforderlich',
      invalidEmail: 'Ungültige E-Mail',
      successMessage: 'Nachricht gesendet. Ich melde mich bald.',
      captchaError: 'Bitte Verifizierung abschließen'
    }
  },
};